import { render, staticRenderFns } from "./maintainlistkids.vue?vue&type=template&id=b62c134e&scoped=true"
import script from "./maintainlistkids.vue?vue&type=script&lang=js"
export * from "./maintainlistkids.vue?vue&type=script&lang=js"
import style0 from "./maintainlistkids.vue?vue&type=style&index=0&id=b62c134e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62c134e",
  null
  
)

export default component.exports